/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Unsaved_ChangesInputs */



/**
* | output |
* | --- |
* | "Unsaved changes" |
*
* @param {Editor_Unsaved_ChangesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_unsaved_changes = /** @type {((inputs?: Editor_Unsaved_ChangesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Unsaved_ChangesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifications non enregistrées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungespeicherte Änderungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifiche non salvate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Несохранённые изменения")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambios sin guardar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未保存的更改")
	if (locale === "ja") return /** @type {LocalizedString} */ ("未保存の変更")
	if (locale === "hi") return /** @type {LocalizedString} */ ("असहेजे गए परिवर्तन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterações não guardadas")
	return /** @type {LocalizedString} */ ("Unsaved changes")
});